import { TagAction, TagActionTypes } from '@completion/actions';
import { byTagNumber, CheckSheetAssignment, Tag, TagProjection } from '@completion/models';
import { sortByCheckSheet, sortByTag } from '@completion/utils';

export const initialState: TagState = {
  availableTags: [],
  searchTags: [],
  tagProjections: new Map<string, TagProjection>(),
};

export interface TagState {
  availableTags: Tag[];
  searchTags?: CheckSheetAssignment[];
  tagProjections?: Map<string, TagProjection>;
}

export function tagReducer(state: TagState = initialState, action: TagAction): TagState {
  switch (action.type) {
    case TagActionTypes.LoadAvailableTagsSuccess:
      return {
        ...state,
        availableTags: [...action.tags].sort(byTagNumber),
      };
    case TagActionTypes.LoadSearchTagsSuccess:
      const searchTags = [...action.csas].sort((a, b) => sortByTag(a, b) || sortByCheckSheet(a, b));
      return {
        ...state,
        searchTags,
      };
    case TagActionTypes.LoadTagProjectionsSuccess:
      return {
        ...state,
        tagProjections: new Map(action.projections.map((p) => [p.tagNumber, p])),
      };
    default:
      return state;
  }
}
